define.alias("shared/components/shared/mobile/drawer/feature-drawer", "calendar/components/shared/mobile/drawer/feature-drawer");